import { useTranslation } from "react-i18next";
import { useWizard } from "../../../components/Wizard/Wizard";
import { capitalizeFirstLetter } from "../../../utils/generic";
import ConfirmationStep, {
  ConfirmationStepAddToCalendar,
  ConfirmationStepContact,
  ConfirmationStepExtra,
  ConfirmationStepSummary,
} from "../ConfirmationStep";

export default function ConfirmationEnvironmentalStep() {
  const { t } = useTranslation();
  const {
    subscriber,
    values: { appointment_type, timeslot },
  } = useWizard();
  const title = capitalizeFirstLetter(appointment_type);

  return (
    <ConfirmationStep
      title={t("pages.booking.shared.steps.confirmation.title", {
        appointment_type: title,
      })}
    >
      <ConfirmationStepSummary
        endDatetime={timeslot.end_datetime}
        instructionKey={
          subscriber === "enterprise"
            ? "pages.booking.environmental.steps.confirmation.company.instructions"
            : "pages.booking.environmental.steps.confirmation.private.instructions"
        }
        startDatetime={timeslot.start_datetime}
        title={t("pages.booking.environmental.steps.confirmation.title")}
      />
      <ConfirmationStepExtra>
        <ConfirmationStepContact />
        <ConfirmationStepAddToCalendar
          endDatetime={timeslot.end_datetime}
          startDatetime={timeslot.start_datetime}
          subject={t("pages.booking.environmental.title")}
        />
      </ConfirmationStepExtra>
    </ConfirmationStep>
  );
}
